// extracted by mini-css-extract-plugin
module.exports =  {"banner":"_373a3719ba--banner--wSL9n","title":"_373a3719ba--title--IEkwG","icon":"_373a3719ba--icon--PSfL2","text":"_373a3719ba--text--iYktI"};